import React from 'react';
import { Stack } from '@mui/material';
import { Button, ButtonOrLinkProps } from '../Button';

export type ConfirmOption = {
	text: string;
	className?: string;
	color?: ButtonOrLinkProps['color'];
	callback: () => void;
	loading?: boolean;
	dataCy?: string;
};

type ButtonsProps = {
	options?: ConfirmOption[];
};

const Buttons: React.FC<ButtonsProps> = ( { options } ) => {
	if ( !options ) return null;

	return (
		<Stack direction={ { xs: 'column', md: 'row' } } spacing={ 2 }>
			{ options.map( ( option, index ) => (
				<Button
					key={ index }
					variant={
						option.className === 'button--ghost' ? 'outlined' : 'contained'
					}
					color={ option.color }
					onClick={ option.callback }
					loading={ option.loading }
					data-cy={ option.dataCy }
				>
					{ option.text }
				</Button>
			) ) }
		</Stack>
	);
};

export default Buttons;
